module.exports = __webpack_public_path__ + "static/img/shezhi_yaoqing.daff4547.png";